<template>
  <div class="dashboard-bar-row">
    <div class="d-flex align-baseline">
      <span class="text-body-2 text--primary">{{ label }}</span>
      <v-spacer></v-spacer>
      <span
        v-if="note"
        class="text-caption text--secondary ms-2"
      >{{ note }}</span>
      <span class="dashboard-bar-row__value text-body-2 text--primary font-weight-semibold">{{ value }}</span>
    </div>
    <div class="dashboard-bar-row__track">
      <div
        class="dashboard-bar-row__fill"
        :style="{ width: `${width}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardBarRow',
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    note: { type: String, default: '' },

    fraction: { type: Number, default: null },
  },
  computed: {
    width() {
      return this.fraction === null ? 0 : Math.max(0, Math.min(1, this.fraction)) * 100
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-bar-row {
  & + & {
    margin-top: 12px;
  }

    .dashboard-bar-row__value {
    min-width: 3.5rem;
    text-align: right;
    white-space: nowrap;
  }

  .dashboard-bar-row__track {
    position: relative;
    height: 6px;
    margin-top: 4px;
    border-radius: 3px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: currentColor;
      opacity: 0.08;
    }
  }

  .dashboard-bar-row__fill {
    position: relative;
    height: 100%;
    border-radius: 3px;
    background: var(--v-primary-base);
  }
}
</style>
